
















import { computed, defineComponent, PropType } from "@vue/composition-api";
import { Location } from "vue-router/types/router";
import { BaseMenuItem } from "@/types";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseIconButton from "@/components/BaseIconButton";
import BaseMenu from "@/components/BaseMenu";

export default defineComponent({
  name: "GalleryFilters",
  components: { BaseIconButton, BaseIcon, BaseMenu },
  props: {
    location: { type: Object as PropType<Location>, required: true },
    filterItems: { type: Array as PropType<BaseMenuItem[]>, required: true },
    isFeedView: { type: Boolean, default: false },
    activeType: { type: String },
  },
  setup(props, { root }) {
    const activeFilter = computed(
      () => props.filterItems.find(i => i.name === props.activeType) || props.filterItems[0]
    );

    const onSubmitFilter = (name: string) => {
      if (name === props.activeType) return;
      root.$router.push({
        ...props.location,
        params: { ...root.$route.params },
        query: { ...root.$route.query, type: name },
      });
    };

    return { activeFilter, onSubmitFilter };
  },
});
